import { render } from "./BanModal.vue?vue&type=template&id=6b3c8efc&scoped=true"
import script from "./BanModal.vue?vue&type=script&lang=js"
export * from "./BanModal.vue?vue&type=script&lang=js"

import "./BanModal.vue?vue&type=style&index=0&id=6b3c8efc&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6b3c8efc"

export default script